import { ApiMetadataRetriever } from "@mcleod/core";
import { ReadOnlyTextAreaPanel } from "../ReadOnlyTextAreaPanel";
import { MenuEditorTreeNode } from "../MenuEditorTreeNode";
import { MenuAction } from "./MenuAction";
import { MenuActionSQLUtils } from "./MenuActionSQLUtils";

export class MenuActionInsertScript extends MenuAction {
    private itemStatements: Map<string, string> = new Map();
    private groupStatements: Map<string, string> = new Map();

    override validate(): boolean {
        return this.node != null;
    }

    protected async internalExecute(): Promise<boolean> {
        await ApiMetadataRetriever.get("common/web-menu-group");
        await ApiMetadataRetriever.get("common/web-menu-item");

        this.generateInsertStatements(this.node);

        const thisNodeStatements = [
            ...this.itemStatements.values(),
            ...this.groupStatements.values()
        ];

        let childStatements = [];

        if (this.node.hasChildren()) {
            for (const child of this.node.children) {
                this.generateInsertStatementsRecursively(child);
            }
            childStatements = [
                ...this.itemStatements.values(),
                ...this.groupStatements.values()
            ].filter(statement => !thisNodeStatements.includes(statement));

            if (childStatements.length > 0) {
                childStatements.unshift("\n-- Child Data --");
            }
        }


        const allStatements = [
            ...thisNodeStatements,
            ...childStatements
        ];

        ReadOnlyTextAreaPanel.showInDialog(allStatements, { title: this.getActionTitle("Insert Script") });
        this.menuItemToSelect = this.node.menuItem;

        return true;
    }

    private generateInsertStatements(node: MenuEditorTreeNode) {
        const { itemData, groupData, groupReferenceData } = node.menuItem;

        const itemId = itemData.get("id");
        if (itemId && !this.itemStatements.has(itemId)) {
            this.itemStatements.set(itemId, this.createInsertStatement("web_menu_item", this.getInsertData(itemData)));
        }

        const groupId = groupData.get("id");
        if (groupId && !this.groupStatements.has(groupId)) {
            this.groupStatements.set(groupId, this.createInsertStatement("web_menu_group", this.getInsertData(groupData)));
        }

        const groupReferenceId = groupReferenceData?.get("id");
        if (groupReferenceId && !this.groupStatements.has(groupReferenceId)) {
            this.groupStatements.set(groupReferenceId, this.createInsertStatement("web_menu_group", this.getInsertData(groupReferenceData)));
        }
    }

    private generateInsertStatementsRecursively(node: MenuEditorTreeNode) {
        this.generateInsertStatements(node);
        if (node.hasChildren()) {
            for (const child of node.children) {
                this.generateInsertStatements(child);
            }
        }
    }

    private createInsertStatement(tableName: string, insertData: Record<string, any>): string {
        return MenuActionSQLUtils.createInsertStatement(tableName, insertData);
    }

    private getInsertData(modelRow: any): Record<string, any> {
        return MenuActionSQLUtils.getInsertData(modelRow);
    }
}
